import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { id: "home", label: "HOME" },
  { id: "services", label: "SERVICES" },
  { id: "work", label: "WORK" },
  { id: "about", label: "ABOUT" },
  { id: "contact", label: "CONTACT" },
];

export const FloatingNav = () => {
  const [active, setActive] = useState("home");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px" }
    );
    LINKS.forEach((l) => {
      const el = document.getElementById(l.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <motion.nav
      data-testid="floating-nav"
      initial={{ y: 90, opacity: 0, x: "-50%" }}
      animate={{ y: 0, opacity: 1, x: "-50%" }}
      transition={{ delay: 1.1, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-4 sm:bottom-6 left-1/2 z-50 flex items-center gap-0.5 rounded-full border border-white/60 bg-white/35 backdrop-blur-2xl backdrop-saturate-150 px-1.5 py-1.5 overflow-hidden shadow-[0_18px_50px_rgba(18,19,20,0.14),0_2px_8px_rgba(18,19,20,0.06),inset_0_1px_0_rgba(255,255,255,0.85),inset_0_-1px_1px_rgba(255,255,255,0.35)]"
      aria-label="Primary"
    >
      <span className="pointer-events-none absolute inset-0 rounded-full bg-gradient-to-b from-white/50 via-white/5 to-white/10" aria-hidden="true" />
      {LINKS.map((l) => (
        <button
          key={l.id}
          data-testid={`nav-link-${l.id}`}
          onClick={() => scrollToId(l.id)}
          className={`relative px-3 sm:px-4 py-2 text-[10px] sm:text-[11px] font-semibold tracking-[0.14em] transition-colors duration-300 rounded-full ${
            active === l.id ? "text-cream" : "text-charcoal/60 hover:text-charcoal"
          }`}
        >
          {active === l.id && (
            <motion.span
              layoutId="nav-active-pill"
              className="absolute inset-0 bg-charcoal/90 rounded-full shadow-[inset_0_1px_0_rgba(255,255,255,0.15)]"
              transition={{ type: "spring", stiffness: 380, damping: 32 }}
            />
          )}
          <span className="relative z-10">{l.label}</span>
        </button>
      ))}
    </motion.nav>
  );
};
